import React, { Component } from 'react';
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { withTranslation } from 'next-i18next';
import 'swiper/css';
import "swiper/css/navigation";
import Router from 'next/router';

// To include the default styles
import 'react-rangeslider/lib/index.css';

// import { debounce } from "lodash";
import { DebounceInput } from 'react-debounce-input';

// Styles
import styles from "./CommonFilterDesktop.module.scss";

class CommonFilterHeader extends Component {
    state = {
        sortListDropdown: !this.props.favFilter ?
        [
            { value: 0, label: this.props.t('common:price_low_high') },
            { value: 1, label: this.props.t('common:price_hign_low') },
            { value: 2, label: this.props.t('common:recently_listed') }
        ]
        :[
            { value: 0, label: this.props.t('common:price_low_high') },
            { value: 1, label: this.props.t('common:price_hign_low') },
            { value: 2, label: this.props.t('common:recently_listed') },
            { value: 3, label: this.props.t('common:most_viewed') },
            { value: 4, label: this.props.t('common:most_favorited') },
        ],
        sort: [
            { value: 0, label: this.props.t('common:price_low_high') }
        ],
        isOpen : true

    };

    componentDidMount = ()=>{
       if( window.innerWidth  < 768){
            this.setState({...this.state,isOpen : false})
       }
    }

    handleSorting = (sort) => {
        this.setState({ sort }, () => {
            this.props.changePriceSort(sort.value);
        });
    };

    ftoggle = (e) => {
        e.preventDefault()
        document.getElementById("cmnFltr").classList.toggle("FilterOpen");
    }
    onFilterButtonClick = () => {
        this.setState({ isOpen: !this.state.isOpen })
        if(this.props.onFilterClick){
            this.props.onFilterClick()
        }
    }
    render() {
        const { t } = this.props;
        const router = Router.router

        return (
            <Accordion id="cmnFltr" className={` ${styles.accordion} ${this.state.isOpen ? 'FilterOpen' : ''}`} activeKey={this.state.isOpen ? 0 : null}>
                <Card className="border-0 bg-transparent">
                    <Card.Header>
                        <div className={`d-flex flex-wrap justify-content-between ${styles.NewFilerHeader}`}>
                            <Button
                                type="button"
                                onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                                className={`btn buttonStroke d-none d-md-block  ${styles.filterBtn} ${this.state.isOpen ? 'Filterbtn_Active' : ''}`}>
                                {t('common:filter')}
                                    <svg className={styles.opendsvg} width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.05752 1.05703C1.57822 0.536329 2.42244 0.536329 2.94313 1.05703L10.0003 8.11422L17.0575 1.05703C17.5782 0.536329 18.4224 0.536329 18.9431 1.05703C19.4638 1.57773 19.4638 2.42195 18.9431 2.94265L11.8859 9.99984L18.9431 17.057C19.4638 17.5777 19.4638 18.4219 18.9431 18.9426C18.4224 19.4633 17.5782 19.4633 17.0575 18.9426L10.0003 11.8855L2.94314 18.9426C2.42244 19.4633 1.57822 19.4633 1.05752 18.9426C0.536818 18.4219 0.536818 17.5777 1.05752 17.057L8.11471 9.99984L1.05752 2.94265C0.536817 2.42195 0.536817 1.57773 1.05752 1.05703Z" fill="#fcfcfd" />
                                    </svg>
                                    <svg className={styles.defltsvg} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12.0001 11.6972C12.0001 11.4998 12.0585 11.3068 12.168 11.1425L17.2266 3.5547C17.6696 2.89015 17.1932 2 16.3945 2H3.60563C2.80693 2 2.33054 2.89015 2.77358 3.5547L7.83213 11.1425C7.94164 11.3068 8.00008 11.4998 8.00008 11.6972V17.5873C8.00008 18.3727 8.86403 18.8515 9.53008 18.4353L11.5301 17.1853C11.8225 17.0025 12.0001 16.682 12.0001 16.3373V11.6972ZM14.0001 12.3028C14.0001 12.1054 14.0585 11.9123 14.168 11.7481L18.8907 4.6641C20.2198 2.67044 18.7906 0 16.3945 0H3.60563C1.20955 0 -0.21963 2.67043 1.10948 4.6641L5.83213 11.7481C5.94164 11.9123 6.00008 12.1054 6.00008 12.3028V17.5873C6.00008 19.9436 8.59193 21.3801 10.5901 20.1313L12.5901 18.8813C13.4672 18.333 14.0001 17.3716 14.0001 16.3373V12.3028Z" fill="#fcfcfd" />
                                    </svg>
                            </Button>
                            <Button
                                type="button"
                                onClick={this.ftoggle}
                                className={`btn buttonStroke d-block d-md-none ${styles.filterBtn} ${this.state.isOpen ? 'Filterbtn_Active' : ''}`}>
                                {t('common:filter')}
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.0001 11.6972C12.0001 11.4998 12.0585 11.3068 12.168 11.1425L17.2266 3.5547C17.6696 2.89015 17.1932 2 16.3945 2H3.60563C2.80693 2 2.33054 2.89015 2.77358 3.5547L7.83213 11.1425C7.94164 11.3068 8.00008 11.4998 8.00008 11.6972V17.5873C8.00008 18.3727 8.86403 18.8515 9.53008 18.4353L11.5301 17.1853C11.8225 17.0025 12.0001 16.682 12.0001 16.3373V11.6972ZM14.0001 12.3028C14.0001 12.1054 14.0585 11.9123 14.168 11.7481L18.8907 4.6641C20.2198 2.67044 18.7906 0 16.3945 0H3.60563C1.20955 0 -0.21963 2.67043 1.10948 4.6641L5.83213 11.7481C5.94164 11.9123 6.00008 12.1054 6.00008 12.3028V17.5873C6.00008 19.9436 8.59193 21.3801 10.5901 20.1313L12.5901 18.8813C13.4672 18.333 14.0001 17.3716 14.0001 16.3373V12.3028Z" fill="#fcfcfd" />
                                </svg>
                            </Button>
                            <div className={styles.icon}>
                                <button className={styles.search} type="button" aria-label='search'>
                                    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.4212 12.6002C10.2923 13.4778 8.87376 14.0003 7.33317 14.0003C3.65127 14.0003 0.666504 11.0156 0.666504 7.33366C0.666504 3.65176 3.65127 0.666992 7.33317 0.666992C11.0151 0.666992 13.9998 3.65176 13.9998 7.33366C13.9998 8.87425 13.4773 10.2928 12.5997 11.4217L17.0891 15.9111C17.4145 16.2365 17.4145 16.7641 17.0891 17.0896C16.7637 17.415 16.236 17.415 15.9106 17.0896L11.4212 12.6002ZM12.3332 7.33366C12.3332 10.0951 10.0946 12.3337 7.33317 12.3337C4.57175 12.3337 2.33317 10.0951 2.33317 7.33366C2.33317 4.57224 4.57175 2.33366 7.33317 2.33366C10.0946 2.33366 12.3332 4.57224 12.3332 7.33366Z" fill="#777E90" />
                                    </svg>
                                </button>
                                <DebounceInput
                                    debounceTimeout={300}
                                    className={`form-control ${styles.header__input}`}
                                    type="text"
                                    value={this.props.search}
                                    placeholder={t('common:search_filter')}
                                    onChange={this.props.changeSearch} />

                                {/* <Form.Control className={styles.header__input} value={this.state.search} onChange={this.changeSearch} type="text" placeholder={t('common:search_filter')} /> */}
                                {this.state.isClose ?
                                    <button className={styles.close} type="submit" onClick={this.closeSearch}>
                                        <svg className="search_close" width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976309 1.31658 -0.0976309 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683418 14.0976 0.292893 13.7071C-0.0976309 13.3166 -0.0976309 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893Z" fill="#777E90" />
                                        </svg>
                                    </button>
                                    : null
                                }
                            </div>
                            {router && router.asPath !== '/nft/live-auction' && this.props.tab !== "collectibles" && this.props.tab !== "created" && this.props.tab !== "activity" ?
                                <div className={`selectMenu ${styles.selectMenu}`}>
                                    <Select
                                        inputId="sort"
                                        value={this.state.sort}
                                        onChange={this.handleSorting}
                                        options={this.state.sortListDropdown}
                                        classNamePrefix="select__Inner"
                                        placeholder={t('common:select')}
                                        isSearchable={false}
                                    />
                                </div> :
                                null}
                        </div>
                    </Card.Header>
                </Card>
            </Accordion>
        )
    }
}
export default withTranslation()(CommonFilterHeader);
